// extracted by mini-css-extract-plugin
export default {"piaohong":"index_piaohong_yYNdb","piaohonglink":"index_piaohonglink_kazFY","close":"index_close_zhGRi"};